import { render, staticRenderFns } from "./Info1Btn.vue?vue&type=template&id=39a4164b&scoped=true&"
import script from "./Info1Btn.vue?vue&type=script&lang=js&"
export * from "./Info1Btn.vue?vue&type=script&lang=js&"
import style0 from "./Info1Btn.vue?vue&type=style&index=0&id=39a4164b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4164b",
  null
  
)

export default component.exports